import { render } from "./circle-progress.vue?vue&type=template&id=22346346&scoped=true"
import script from "./circle-progress.vue?vue&type=script&lang=js"
export * from "./circle-progress.vue?vue&type=script&lang=js"

import "./circle-progress.vue?vue&type=style&index=0&id=22346346&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22346346"]])

export default __exports__